/** @jsx jsx */
import { useStaticQuery, graphql } from "gatsby"
import { jsx, Box } from "theme-ui"
import Img from "gatsby-image"

const Controls = () => {
  const data = useStaticQuery(graphql`
    query controls {
      file(relativePath: { eq: "kozloduy_bw.jpg" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Box sx={{ width: "100%" }}>
      <Img
        sx={{ my: 4, maxWidth: "40em" }}
        fluid={data.file.childImageSharp.fluid}
      />
    </Box>
  )
}

export default Controls
